import React, {useEffect, useState} from 'react';
import './oneChildLine.css';
import {updateSortOneChildProduct} from "../../../../../http/catalogApi";
import {Link} from "react-router-dom";

const OneChildLine = (props) => {
    const [stocks,setStocks] = useState(false);
    const [curStock,setCurStock] = useState(false);
    const [curWarehouse,setCurWarehouse] = useState(false);
    const [warehouses,setWarehouses] = useState(false);

    useEffect(() => {
        let first = false
        if(props.item.child_product_size && props.item.child_product_size.length > 0 ){
            let s = {};
            props.item.child_product_size.forEach(function(item){
                let stocks = JSON.parse(item.childProduct_Size.stocks)
                for(let i in stocks){
                    if(!s[i]){
                        s[i] = []
                    }
                    s[i].push({
                        size: item.size_name,
                        stock: stocks[i]
                    })
                }
            })
            setStocks(s)

            let temp = [];
            let stocks = JSON.parse(props.item.child_product_size[0].childProduct_Size.stocks)

            for(let i in stocks){
                if(props.warehouses[i]){
                    if(!first){
                        first = i
                    }
                    temp.push(props.warehouses[i])
                }
            }
            setWarehouses(temp)
        }

        if(props.warehouses){
            if(!curWarehouse){
                if(stocks['4671abd4-5475-11ed-9d25-fa163e8d47cb']){
                    setCurWarehouse('4671abd4-5475-11ed-9d25-fa163e8d47cb')
                } else if(first) {
                    setCurWarehouse(first)
                }
            }
        }
    }, [props]);

    useEffect(() => {
        if(curWarehouse && stocks){
            if(stocks[curWarehouse]){
                setCurStock(stocks[curWarehouse])
            } else {
                setCurStock(false)
            }
        }
    }, [curWarehouse, stocks]);

    const selectWareHouse = (e) => {
        setCurWarehouse(e.target.value)
    }

    return (
        <div className={"one_child_line_element"}>
            <div className={"one_child_line_item id"}>
                {props.item.id}
            </div>
            <div className={"one_child_line_item img"}>
                <img src={process.env.REACT_APP_API_URL+"uploads/images/"+props.item.product.id+"/"+props.item.id+"/214_"+props.item.img_preview} alt=""/>
            </div>
            <div className="one_child_line_item name">{props.item.name}</div>
            <div className="one_child_line_item color">
                {props.item.color.color_name}
            </div>
            <div className="one_child_line_item color">
                {props.item.product.articul ? props.item.product.articul : "Не задано"}
            </div>
            <div className="one_child_line_item sort">
                {
                    curStock ?
                        curStock.map((item) => {
                            return(<div>{item.size}: {item.stock}</div>)
                        })
                        : ""
                }
            </div>
            <div className="one_child_line_item btn_save" style={{width: '150px'}}>
                {
                    warehouses.length > 0 ?
                        <select onChange={e => selectWareHouse(e)}>
                            {
                                warehouses.map((item) => {
                                    return(<option value={item.code} selected={item.code === curWarehouse ? "selected" : ""}>{item.name}</option>)
                                })
                            }
                        </select>: ""
                }
            </div>
            <Link to={"/admindashboard/products/oneitem/"+props.item.product.id+"/"} className={"one_child_line_item link"}>
                Перейти к товару
            </Link>

        </div>
    );
};

export default OneChildLine;